import { render, staticRenderFns } from "./MQuickMenu.vue?vue&type=template&id=5c58b75b&scoped=true&"
import script from "./MQuickMenu.vue?vue&type=script&lang=js&"
export * from "./MQuickMenu.vue?vue&type=script&lang=js&"
import style0 from "./MQuickMenu.vue?vue&type=style&index=0&id=5c58b75b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c58b75b",
  null
  
)

export default component.exports